"use client";
import { useEffect } from "react";
import { App } from "@capacitor/app";
import { Capacitor, PluginListenerHandle } from "@capacitor/core";

export default function AppBridge() {
  useEffect(() => {
    let appUrlOpen: Promise<PluginListenerHandle> | null = null;
    if (Capacitor.isNativePlatform()) {
      appUrlOpen = App.addListener("appUrlOpen", ({ url }) => {
        //alert(url);
      });
    }

    return () => {
      if (Capacitor.isNativePlatform() && appUrlOpen != null) {
        appUrlOpen.then((urlOpen) => {
          urlOpen.remove();
        });
      }
    };
  }, []);
  return null;
}
